import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { listReferrals, revokeReferral } from '../api/adminReferrals.api';
import type { ReferralListParams } from '../types';

const key = ['admin', 'referrals'] as const;

export const useReferralList = (params: ReferralListParams) =>
  useQuery({
    queryKey: [...key, params],
    queryFn: () => listReferrals(params),
    staleTime: 10_000,
  });

export const useRevokeReferral = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (publicId: string) => revokeReferral(publicId),
    onSuccess: () => client.invalidateQueries({ queryKey: key }),
  });
};
